import CustomerGroupPage from './customer-group-page'

export default CustomerGroupPage
